import { render, staticRenderFns } from "./BoardAlertMessage.vue?vue&type=template&id=7ddb6598&scoped=true"
import script from "./BoardAlertMessage.vue?vue&type=script&lang=ts"
export * from "./BoardAlertMessage.vue?vue&type=script&lang=ts"
import style0 from "./BoardAlertMessage.vue?vue&type=style&index=0&id=7ddb6598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb6598",
  null
  
)

export default component.exports